import React, {useEffect, useState} from 'react';

import {Navigate} from 'react-big-calendar';

import {fetchPrograms, postPrograms} from "../api/api";
import ProgramPlaner from "../weekPlaner/ProgramPlaner";

export default function WeexDayProgram({date, localizer}){
  const [programms, setProgramms] = useState([[],[],[],[],[],[],[]])
  const [selectedCourseType, setSelectedCourseType] = useState(0)

  function save(data){
    console.log(data)
    const jsonString = JSON.stringify(data.map(e => e.filter(e => e.fixed === undefined)));

    postPrograms(date.toLocaleDateString('de-DE'), date.toLocaleDateString('de-DE'), selectedCourseType.short, jsonString).then((a)=>setProgramms(a.days))
  }

  async function fetch(){
    return await fetchPrograms(date.toLocaleDateString('de-DE'), date.toLocaleDateString('de-DE'), selectedCourseType.short)
  }
  useEffect( () => {
    if(selectedCourseType)
      fetch().then((week)=>setProgramms(week.days))
  },[date, selectedCourseType])

  return (<div>
      <ProgramPlaner weekProgramm={programms} onSave={save} setSelectedCourseType={setSelectedCourseType} selectedCourseType={selectedCourseType} startOfWeek={date} date={date}/>
    </div>
  );
}

WeexDayProgram.navigate = (date, action, {localizer}) => {
  switch(action){
    case Navigate.PREVIOUS:
      return localizer.add(date, -1, 'day');

    case Navigate.NEXT:
      return localizer.add(date, 1, 'day');

    default:
      return date;
  }
};

WeexDayProgram.title = (date, {localizer}) => {
  return `${date.toLocaleDateString('de-DE')}`;
};